import React from 'react';

const MarketToggle = ({
  showOffMarket,
  setShowOffMarket,
  offMarketProperties,
  onMarketListings,
  setListings,
}) => {
  // Updated container style with a white background and a subtle border.
  const pillContainerStyle = {
    display: 'flex',
    width: '150px',
    minHeight: '40px',
    borderRadius: '999px',
    backgroundColor: 'white', // white background for the pill
    overflow: 'hidden',
    cursor: 'pointer',
    margin: '20px auto',
    marginTop:'-3px',
    border: '1px solid #ccc', // optional light border
  };

  // Shared segment style with a smaller font size.
  const segmentStyle = {
    flex: 1,
    display: 'flex', // centers the text both vertically and horizontally
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    transition: 'background-color 0.3s, color 0.3s',
    userSelect: 'none',
    fontWeight: 'bold',
    fontSize: '12px', // smaller text for readability
  };

  // Left ("On Market") style: active when showOffMarket is false.
  const onMarketStyle = {
    ...segmentStyle,
    backgroundColor: showOffMarket ? 'transparent' : '#007aff',
    color: showOffMarket ? '#007aff' : '#fff',
  };

  // Right ("Off Market") style: active when showOffMarket is true.
  const offMarketStyle = {
    ...segmentStyle,
    backgroundColor: showOffMarket ? '#007aff' : 'transparent',
    color: showOffMarket ? '#fff' : '#007aff',
  };

  const handleToggleOffMarket = () => {
    const newValue = !showOffMarket;
    setShowOffMarket(newValue);
    if (newValue) {
      setListings(offMarketProperties);
    } else {
      setListings(onMarketListings);
    }
  };

  return (
    <div style={pillContainerStyle} onClick={handleToggleOffMarket}>
      <span style={onMarketStyle}>On Market</span>
      <span style={offMarketStyle}>Off Market</span>
    </div>
  );
};

export default MarketToggle;
